<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>
        <div class="row" v-if="!loading">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        Zarządzanie newsami
                    </div>
                    <div class="card-body">
                        <data-table
                            :items="data"
                            :fields="fields"
                            edit
                            v-on:edit="openEditModal"
                            delete
                            v-on:delete="handleDelete"
                        >
                            <template v-slot:content="row">
                                <span v-html="row.value.slice(0, 50)"></span>
                            </template>
                            <template v-slot:landing_page="row">
                                <ul style="list-style: none; padding-left: 0;">
                                    <li>Strona główna: <i v-if="row.item.landing_page" class="fa fa-check text-success"></i><i v-else class="fa fa-times text-danger"></i></li>
                                    <li>Panel: <i v-if="row.item.dashboard" class="fa fa-check text-success"></i><i v-else class="fa fa-times text-danger"></i></li>
                                    <li>TeamSpeak: <i v-if="row.item.teamspeak" class="fa fa-check text-success"></i><i v-else class="fa fa-times text-danger"></i></li>
                                </ul>
                            </template>
                            <template v-slot:only_admins="row">
                                <span v-if="row.value" class="text-success"><i class="fa fa-check"></i> TAK </span>
                                <span v-else class="text-danger"><i class="fa fa-times"></i> NIE </span>
                            </template>
                            <template v-slot:updated_at="row">
                                {{ row.value | moment("DD-MM-YYYY HH:mm") }}
                            </template>
                            <template v-slot:created_at="row">
                                {{ row.value | moment("DD-MM-YYYY HH:mm") }}
                            </template>
                            <template v-slot:client="row">
                                <client :client="row.value" withAvatar/>
                            </template>
                        </data-table>
                        <div class="d-flex justify-content-center">
                            <button v-b-modal.modal-add class="btn btn-success">
                                <i class="fa fa-plus"></i> Dodaj newsa
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="modal-add"
            centered
            title="Dodaj nowego newsa"
            title-class="font-18"
            size="lg"
        >
            <div>
                <form class="needs-validation" @submit.prevent="() => {}">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="add-title">Nagłówek</label>
                                <input
                                    id="add-title"
                                    v-model="addNews.title"
                                    :class="{ 'is-invalid': $v.addNews.title.$error }"
                                    class="form-control"
                                    placeholder="Mój pierwszy kanał"
                                    type="text"
                                />
                                <div v-if="$v.addNews.title.$error" class="invalid-feedback">
                                    <span v-if="!$v.addNews.title.required">Nagłówek jest wymagany.</span>
                                    <span v-if="!$v.addNews.title.minLength">Nagłówek musi mieć co najmniej 5 znaków.</span>
                                    <span v-if="!$v.addNews.title.maxLength">Nagłówek musi mieć maksymalnie 100 znaków.</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="add-content">Zawartość</label>
                                <ckeditor
                                    id="add-content"
                                    v-model="addNews.content"
                                    :class="{ 'is-invalid': $v.addNews.content.$error }"
                                    :editor="editor"
                                    :config="editorConfig"
                                />
                                <div v-if="$v.addNews.content.$error" class="invalid-feedback">
                                    <span v-if="!$v.addNews.content.required">Zawartość jest wymagany.</span>
                                    <span v-if="!$v.addNews.content.minLength">Zawartość musi mieć co najmniej 5 znaków.</span>
                                    <span v-if="!$v.addNews.content.maxLength">Zawartość musi mieć maksymalnie 100 znaków.</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="add-landing_page">Wyświetlanie na stronie</label><br>
                                <switches
                                    id="add-landing_page"
                                    v-model="addNews.landing_page"
                                    color="primary"
                                    type-bold="true"
                                    class="m-2"
                                />
                            </div>
                            <div class="form-group">
                                <label for="add-dashboard">Wyświetlanie w panelu</label><br>
                                <switches
                                    id="add-dashboard"
                                    v-model="addNews.dashboard"
                                    color="primary"
                                    type-bold="true"
                                    class="m-2"
                                />
                            </div>
                            <div class="form-group">
                                <label for="add-teamspeak">Wyświetlanie w TeamSpeaku</label><br>
                                <switches
                                    id="add-teamspeak"
                                    v-model="addNews.teamspeak"
                                    color="primary"
                                    type-bold="true"
                                    class="m-2"
                                />
                            </div>
                            <div class="form-group">
                                <label for="add-only_admins">Tylko dla admina</label><br>
                                <small>Newsy przeznaczone dla admina będą się wyświetlać tylko w tym panelu</small><br><br>
                                <switches
                                    id="add-only_admins"
                                    v-model="addNews.only_admins"
                                    color="danger"
                                    type-bold="true"
                                    class="m-2"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <b-button
                        variant="primary"
                        size="sm"
                        class="float-right"
                        @click="handleAdd"
                    >
                        <i class="fa fa-plus"></i> Dodaj newsa
                    </b-button>
                </div>
            </template>
        </b-modal>
        <b-modal
            id="modal-edit"
            centered
            title="Edytujesz newsa"
            title-class="font-18"
            size="lg"
        >
            <div>
                <form class="needs-validation" @submit.prevent="() => {}" v-if="currentNews.title">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="edit-title">Nagłówek</label>
                                <input
                                    id="edit-title"
                                    v-model="currentNews.title"
                                    :class="{ 'is-invalid': $v.currentNews.title.$error }"
                                    class="form-control"
                                    placeholder="Mój pierwszy kanał"
                                    type="text"
                                />
                                <div v-if="$v.currentNews.title.$error" class="invalid-feedback">
                                    <span v-if="!$v.currentNews.title.required">Nagłówek jest wymagany.</span>
                                    <span v-if="!$v.currentNews.title.minLength">Nagłówek musi mieć co najmniej 5 znaków.</span>
                                    <span v-if="!$v.currentNews.title.maxLength">Nagłówek musi mieć maksymalnie 100 znaków.</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="edit-content">Zawartość</label>
                                <ckeditor
                                    id="edit-content"
                                    v-model="currentNews.content"
                                    :class="{ 'is-invalid': $v.addNews.content.$error }"
                                    :editor="editor"
                                    :config="editorConfig"
                                />
                                <div v-if="$v.currentNews.content.$error" class="invalid-feedback">
                                    <span v-if="!$v.currentNews.content.required">Zawartość jest wymagany.</span>
                                    <span v-if="!$v.currentNews.content.minLength">Zawartość musi mieć co najmniej 5 znaków.</span>
                                    <span v-if="!$v.currentNews.content.maxLength">Zawartość musi mieć maksymalnie 100 znaków.</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="edit-landing_page">Wyświetlanie na stronie</label><br>
                                <switches
                                    id="edit-landing_page"
                                    v-model="currentNews.landing_page"
                                    color="primary"
                                    type-bold="true"
                                    class="m-2"
                                />
                            </div>
                            <div class="form-group">
                                <label for="edit-dashboard">Wyświetlanie w panelu</label><br>
                                <switches
                                    id="edit-dashboard"
                                    v-model="currentNews.dashboard"
                                    color="primary"
                                    type-bold="true"
                                    class="m-2"
                                />
                            </div>
                            <div class="form-group">
                                <label for="edit-teamspeak">Wyświetlanie w TeamSpeaku</label><br>
                                <switches
                                    id="edit-teamspeak"
                                    v-model="currentNews.teamspeak"
                                    color="primary"
                                    type-bold="true"
                                    class="m-2"
                                />
                            </div>
                            <div class="form-group">
                                <label for="edit-only_admins">Tylko dla admina</label><br>
                                <small>Newsy przeznaczone dla admina będą się wyświetlać tylko w tym panelu</small><br><br>
                                <switches
                                    id="edit-only_admins"
                                    v-model="currentNews.only_admins"
                                    color="danger"
                                    type-bold="true"
                                    class="m-2"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <b-button
                        variant="primary"
                        size="sm"
                        class="float-right"
                        @click="handleEdit"
                    >
                        <i class="fa fa-save"></i> Zapisz zmiany
                    </b-button>
                </div>
            </template>
        </b-modal>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import NewsService from "@/services/news.service";
import Switches from "vue-switches";
import {
    notificationMethods
} from "@/state/helpers";
import {
    required,
    minLength,
    maxLength,
} from "vuelidate/lib/validators";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

/**
 * Starter component
 */
export default {
    name: "News",
    components: {Layout, PageHeader, Switches, ckeditor: CKEditor.component},
    data() {
        return {
            title: "Newsy",
            items: [
                {
                    text: "Admin",
                    href: "/"
                },
                {
                    text: "Newsy",
                    active: true
                }
            ],
            loading: true,
            data: {},
            fields: [
                {key: "id", sortable: true},
                {key: "title", label: "Nagłówek"},
                {key: "content", label: "Zawartość"},
                {key: "landing_page", label: "Wyświetlanie"},
                {key: "only_admins", label: "Tylko dla adminów"},
                {key: "client", label: "Autor"},
                {key: "updated_at", label: "Zedytowany", sortable: true},
                {key: "created_at", label: "Utworzony", sortable: true},
            ],
            currentNews: {},
            addNews: {},
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        //'link',
                        'bulletedList',
                        'numberedList',
                        //'imageUpload',
                        'blockQuote',
                        'undo',
                        'redo'
                    ]
                },
            }
        };
    },
    validations: {
        addNews: {
            title: {required, minLength: minLength(5), maxLength: maxLength(100)},
            content: {required, minLength: minLength(10), maxLength: maxLength(3000)},
            landing_page: {required},
            dashboard: {required},
            teamspeak: {required},
            only_admins: {required}
        },
        currentNews: {
            title: {required, minLength: minLength(5), maxLength: maxLength(100)},
            content: {required, minLength: minLength(10), maxLength: maxLength(3000)},
            landing_page: {required},
            dashboard: {required},
            teamspeak: {required},
            only_admins: {required}
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ...notificationMethods,
        loadData() {
            this.loading = true;

            NewsService.getAll().then(
                response => {
                    this.data = response.data;
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        handleAdd() {
            this.$v.addNews.$touch();

            if (this.$v.addNews.$invalid) {
                return;
            } else {
                this.$bvModal.hide("modal-add");
                this.loading = true;


                NewsService.save(this.addNews).then(
                    () => {
                        this.success("News został dodany!");
                        this.addNews = {};
                        this.loadData();
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
        handleDelete(row) {
            this.loading = true;

            NewsService.delete(row.id).then(
                () => {
                    this.success("News został usunięty");
                    this.loadData();
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        openEditModal(row) {
            this.currentNews = row;
            this.$bvModal.show("modal-edit");
        },
        handleEdit() {
            this.$v.currentNews.$touch();

            if (this.$v.currentNews.$invalid) {
                return;
            } else {
                this.$bvModal.hide("modal-edit");
                this.loading = true;

                NewsService.edit(this.currentNews.id, this.currentNews).then(
                    () => {
                        this.success("News został zedytowany");
                        this.currentNews = {};
                        this.loadData();
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
    }
};
</script>